export const PURCHASE = {
  value: "purchase",
  name: "Purchase",
};

const pms_purpose_of_loan = [
  PURCHASE,
  { value: "refinance", name: "Refinance" },
  { value: "refinance_co", name: "Refinance C/O" },
];

export default pms_purpose_of_loan;



// WEBPACK FOOTER //
// ./src/constants/pms_purpose_of_loan.js